var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"session-block-holder"},[_c('div',{staticClass:"session-block"},[_vm._t("default"),_vm._m(0)],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"session-bg-blocks"},[_c('div',{staticClass:"white-block"}),_c('div',{staticClass:"color-block-one"}),_c('div',{staticClass:"color-block-two"})])
}]

export { render, staticRenderFns }